import type { ActionNodeData } from "../nodes/ActionNode";


export function getActionDraftResetForTypePicker(): Partial<ActionNodeData> {
    return {
        actionCode: undefined,
        actionType: undefined,
        title: undefined,
        isPlaceholder: true,
        message: undefined,
        onceOnly: undefined,
        responseType: undefined,
        templateId: undefined,
        templateName: undefined,
        templateIntegId: undefined,
        hasMedia: undefined,
        mediaFileList: undefined,
        components: undefined,
        fieldNameAndValueMap: undefined,
        recordOwner: undefined,
        accountOwner: undefined,
        includeAdditionalEmails: undefined,
        additionalEmails: undefined,
        logRecordAsThread: undefined,
        logRecordsFor: undefined,
        loggingPreference: undefined,
        logRecordsOnStatus: undefined,
        activityType: undefined,
        delayDays: undefined,
        delayHours: undefined,
        delayMinutes: undefined,
        createLead: undefined,
    };
}
